/**
 * Seeded once from grantable-paths.json on 2026-10-08; edit by hand from here.
 *
 * Client Options (per-field edit permissions).
 */

import { tool } from '../builder';

/** Legacy gave every Client Options command the `Action_Inline_Edit` pencil as its security image. */
const EDIT_ICON = { icon: 'edit' } as const;

export const clientOptions = tool('Client Options');
export const copySecurityOptions = clientOptions.command('Copy Security Options', EDIT_ICON);
export const editAllowVaultTransactions = clientOptions.command('Edit: Allow Vault Transactions', EDIT_ICON);
export const editAutomaticallyGenerateForms = clientOptions.command('Edit: Automatically Generate Forms', EDIT_ICON);
export const editDefaultTipTransactionsToTipBox = clientOptions.command('Edit: Default Tip Transactions to Tip Box', EDIT_ICON);
export const editDigitalSignatureType = clientOptions.command('Edit: Digital Signature Type', EDIT_ICON);
export const editFundingVault = clientOptions.command('Edit: Funding Vault', EDIT_ICON);
export const editIsMobile = clientOptions.command('Edit: Is Mobile', EDIT_ICON);
export const editLockedDownCashVault = clientOptions.command('Edit: Locked Down Cash Vault', EDIT_ICON);
export const editLockedDownChipVault = clientOptions.command('Edit: Locked Down Chip Vault', EDIT_ICON);
export const editLockedDownNCVChipVault = clientOptions.command('Edit: Locked Down NCV Chip Vault', EDIT_ICON);
export const editRemindCashiersToRollShift = clientOptions.command('Edit: Remind Cashiers to Roll Shift', EDIT_ICON);
export const editRequireCurrencyBagValidationOnClose = clientOptions.command('Edit: Require Currency Bag Validation On Close', EDIT_ICON);
export const editShowCashierVariance = clientOptions.command('Edit: Show Cashier Variance', EDIT_ICON);
export const editShowOtherCashierShifts = clientOptions.command('Edit: Show Other Cashier Shifts', EDIT_ICON);
export const editSignaturePadShowSummaryPage = clientOptions.command('Edit: Signature Pad - Show Summary Page', EDIT_ICON);
export const editUseOriginalVaultWhenApprovingPendingTransactions = clientOptions.command('Edit: Use Original Vault When Approving Pending Transactions', EDIT_ICON);
export const editWarnIfOpenVault = clientOptions.command('Edit: Warn if Open Vault', EDIT_ICON);
